import type { track as TrackFunction } from "pro-features/components/WithTrack/src/context";
import createTrackingEventName from "app/pages/sales-intelligence/utils/testing/createTrackingEventName";

function createManageOpportunityListTrackingService(track: TrackFunction) {
    const trackAddListPopupEvent = (action: string, eventName: string): void => {
        track("Add list popup", action, eventName);
    };

    return {
        trackDismissHelpClicked(): void {
            const eventName = createTrackingEventName("close pro tip", "add new list ", "dismiss pro tip");

            trackAddListPopupEvent("click", eventName);
        },

        trackListNameChanged(listName: string | undefined): void {
            const eventName = createTrackingEventName("name your list", "add new list", listName ?? "");

            trackAddListPopupEvent("typed list name", eventName);
        },
    };
}

export default function createOpportunityListsTrackingService(track: TrackFunction) {
    return {
        manageList: createManageOpportunityListTrackingService(track),

        trackListOptionsClicked() {
            track("list settings", "open settings", "click settings");
        },
        trackListRenameCancelClicked() {
            track("list settings", "cancel", "save new name/change list name");
        },
        trackListRenameSubmitClicked() {
            track("list settings", "change name", "save new name/change list name");
        },
        trackListDeleteCancelClicked() {
            track("list settings", "cancel", "remove list");
        },
        trackListDeleteSubmitClicked() {
            track("list settings", "delete list", "remove list");
        },
        trackListSelectFromDD(listName: string) {
            track("Lists", "click", `switch list/${listName}`);
        },
    };
}
